import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from "@coreui/react";
import { Language } from "../../language/English";
const ServiceActivateModal = (props: {showActivateModal : boolean, setShowActivateModal : Function, confirmActivate : Function}) => {
    return(
        <CModal alignment="center" visible={props.showActivateModal} onClose={() => props.setShowActivateModal(false)}>
            <CModalHeader>
                <CModalTitle>{Language.ACTIVATE_SERVICE}</CModalTitle>
            </CModalHeader>
            <CModalBody> {Language.ACTIVATE_SERVICE_CONFIRMATION} </CModalBody>
            <CModalFooter>
                <CButton color="secondary" onClick={() => props.setShowActivateModal(false)}> {Language.NO} </CButton>
                <CButton color="primary" onClick={() => props.confirmActivate()}> {Language.YES} </CButton>
            </CModalFooter>
        </CModal>
    )
}
export default ServiceActivateModal;